import { Outlet, RouteObject } from 'react-router';

import { ROUTE } from '@app-evolution-cms/router';

import { ALL_CLAIM_ROLES, ROLE_CLAIM } from '../users/_constants/role-claim';
import { ProtectedRoute } from './_permissions/protected-route';
import { Layout } from './layout';

export const MODULES_CONTENT_ROUTES: RouteObject = {
  path: ROUTE.modulesContent.main,
  element: (
    <ProtectedRoute fallbackPath={ROUTE.root} roles={ALL_CLAIM_ROLES}>
      <Layout>
        <Outlet />
      </Layout>
    </ProtectedRoute>
  ),
  children: [
    {
      index: true,
      async lazy() {
        const { Main } = await import('./main');
        return { Component: Main };
      },
    },
    {
      path: ROUTE.modulesContent.create,
      element: <ProtectedRoute roles={[ROLE_CLAIM.admin, ROLE_CLAIM.editor]} />,
      children: [
        {
          index: true,
          async lazy() {
            const { Create } = await import('./create');
            return { Component: Create };
          },
        },
      ],
    },
    {
      path: ROUTE.modulesContent.edit,
      element: <ProtectedRoute roles={[ROLE_CLAIM.admin, ROLE_CLAIM.editor]} />,
      children: [
        {
          index: true,
          async lazy() {
            const { Edit } = await import('./edit');
            return { Component: Edit };
          },
        },
      ],
    },
    {
      path: ROUTE.modulesContent.upload,
      element: <ProtectedRoute roles={[ROLE_CLAIM.admin, ROLE_CLAIM.editor]} />,
      children: [
        {
          index: true,
          async lazy() {
            const { Upload } = await import('./upload');
            return { Component: Upload };
          },
        },
      ],
    },
  ],
};
